export const EVENT_AUTO_HIDE_GRACE_HOURS = {
  ONE_DAY: 24,
  THREE_DAYS: 72,
  ONE_WEEK: 168,
} as const;

export const EVENT_AUTO_HIDE_GRACE_HOUR_VALUES = [
  EVENT_AUTO_HIDE_GRACE_HOURS.ONE_DAY,
  EVENT_AUTO_HIDE_GRACE_HOURS.THREE_DAYS,
  EVENT_AUTO_HIDE_GRACE_HOURS.ONE_WEEK,
] as const;

export type EventAutoHideGraceHours =
  (typeof EVENT_AUTO_HIDE_GRACE_HOUR_VALUES)[number];

export const DEFAULT_EVENT_AUTO_HIDE_GRACE_HOURS =
  EVENT_AUTO_HIDE_GRACE_HOURS.ONE_DAY;

export const EVENT_TIME_CONFIG = {
  SAME: 'same',
  DIFFERENT: 'different',
} as const;

export const EVENT_WEEKDAY = {
  SUN: 'Sun',
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
} as const;

export const EVENT_WEEKDAY_BY_INDEX = [
  EVENT_WEEKDAY.SUN,
  EVENT_WEEKDAY.MON,
  EVENT_WEEKDAY.TUE,
  EVENT_WEEKDAY.WED,
  EVENT_WEEKDAY.THU,
  EVENT_WEEKDAY.FRI,
  EVENT_WEEKDAY.SAT,
] as const;

export const EVENT_AUTO_HIDE_GRACE_LABEL = {
  [EVENT_AUTO_HIDE_GRACE_HOURS.ONE_DAY]: '24 hours',
  [EVENT_AUTO_HIDE_GRACE_HOURS.THREE_DAYS]: '3 days',
  [EVENT_AUTO_HIDE_GRACE_HOURS.ONE_WEEK]: '1 week',
} as const;

export type EventAvailabilitySlot = {
  day?: string;
  startTime?: string;
  endTime?: string;
};

export type ComputePortalVisibilityEndDateInput = {
  endDate?: Date | string | null;
  endTime?: string | null;
  availability?: EventAvailabilitySlot[] | null;
  timeConfig?: string | null;
  autoHideAfterEnd?: boolean | null;
  autoHideGraceHours?: number | null;
};
